// Helper per rendere leggibili i warning restituiti da siteOverview/siteTimeline.
// Il backend segnala le fonti che non hanno risposto con un nome tecnico
// (es. "rtu-uptime", "queue:WorkflowManager"): senza una etichetta l'utente
// vede solo il conteggio e non sa quale dato manca nella scheda/timeline.

const WARNING_LABELS: Record<string, string> = {
  'sdwan-fortinet': 'SDWAN Fortinet',
  'sdwan-cisco': 'SDWAN Cisco',
  'sdwan-requests': 'Richieste SDWAN',
  collaudi: 'Collaudi SDWAN',
  'collaudo-fortinet': 'Collaudo Fortinet',
  'collaudo-cisco': 'Collaudo Cisco',
  rtu: 'RTU',
  'rtu-ping': 'Ping RTU',
  'rtu-uptime': 'Uptime RTU',
  speedtest: 'Speedtest',
  tickets: 'Ticket',
  'tickets-count': 'Conteggi ticket',
  'tickets-mine-count': 'Ticket assegnati',
  rma: 'RMA',
  nrd: 'NRD',
  voip: 'VOIP',
  mediation: 'Mediation',
  support: 'Support',
  metafield: 'Metafield',
  devices: 'Dispositivi'
}

/** Etichetta leggibile per la fonte che non ha risposto. */
export function warningSourceLabel (source: string | null | undefined): string {
  const key = String(source ?? '').trim()
  if (!key) {
    return 'Fonte sconosciuta'
  }
  const queue = /^queue:(.+)$/i.exec(key)
  if (queue) {
    return `Coda ${queue[1]}`
  }
  const known = WARNING_LABELS[key.toLowerCase()]
  if (known) {
    return known
  }
  // Nome non mappato: mostralo comunque in forma leggibile.
  return key
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^./, (char) => char.toUpperCase())
}

/**
 * Elenco delle fonti non disponibili, senza duplicati e pronto per il banner.
 * Accetta sia `source` (timeline) sia `name` (overview).
 */
export function warningSourceLabels (warnings: { source?: string | null, name?: string | null }[]): string {
  const labels: string[] = []
  warnings.forEach((warning) => {
    const label = warningSourceLabel(warning?.source ?? warning?.name)
    if (label && !labels.includes(label)) {
      labels.push(label)
    }
  })
  return labels.join(', ')
}
